import { render, staticRenderFns } from "./DimensionListItemEditor.vue?vue&type=template&id=5d87892f&scoped=true"
import script from "./DimensionListItemEditor.vue?vue&type=script&lang=js"
export * from "./DimensionListItemEditor.vue?vue&type=script&lang=js"
import style0 from "./DimensionListItemEditor.vue?vue&type=style&index=0&id=5d87892f&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d87892f",
  null
  
)

export default component.exports